import React from "react";
import { Modal, ModalBody, Row, Col, Card, CardBody, Button } from "reactstrap";

const SuccessModal = ({ isOpen, toggle, isSuccess, error }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <Row className="justify-content-center">
        <Col md={12}>
          <Card className="p-4 text-center mb-0">
            {/* Icon */}
            <div className="avatar-lg mx-auto mt-2">
              <div
                className={`avatar-title bg-light ${
                  isSuccess ? "text-success" : "text-danger"
                } display-3 rounded-circle`}
              >
                <i
                  className={
                    isSuccess
                      ? "ri-checkbox-circle-fill"
                      : "ri-close-circle-fill"
                  }
                ></i>
              </div>
            </div>

            {/* Message */}
            <div className="mt-4 pt-2">
              <h4 className="fw-bold">
                {isSuccess ? "Successfully Saved!" : "Save Failed!"}
              </h4>
              <p className="text-muted">
                {isSuccess
                  ? "Your data has been successfully saved."
                  : `${
                      error ? error : "Something went wrong. Please try again."
                    }`}
              </p>
            </div>

            {/* Close Button */}
            <div className="mt-4">
              <Button
                color={isSuccess ? "success" : "danger"}
                className="w-100"
                onClick={toggle}
              >
                Close
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export default SuccessModal;
